"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.show = show;
exports.PaymentsModal = exports.PaymentsBody = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = babelHelpers.interopRequireDefault(require("modals/base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _descriptor, _descriptor2, _temp, _class3, _descriptor3, _descriptor4, _temp2, _class5, _temp3, _class7, _descriptor5, _descriptor6, _descriptor7, _temp4;

var NoOp = function NoOp() {};

function getSubscriptionPrice(object) {
  var base_price = object.plan.amount;
  var discount = 0;

  if (object.discount) {
    discount = object.discount.coupon.amount_off ? object.discount.coupon.amount_off : Math.floor(object.plan.amount * (0.01 * object.discount.coupon.percent_off));
  }

  var final_price = base_price - discount;
  return _react.default.createElement("span", {
    className: "price".concat(discount ? " with-discount" : '')
  }, _react.default.createElement("span", {
    className: "base-price"
  }, "$", (base_price / 100).toFixed(2), "/", object.plan.interval_count == 1 ? object.plan.interval : "".concat(object.plan.interval_count, " ").concat(object.plan.interval, "s")), discount > 0 && _react.default.createElement("span", {
    className: "final-price"
  }, "$", (final_price / 100).toFixed(2), "/", object.plan.interval_count == 1 ? object.plan.interval : "".concat(object.plan.interval_count, " ").concat(object.plan.interval, "s")));
}

var PaymentEvent = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(PaymentEvent, _Component);

  function PaymentEvent() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, PaymentEvent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(PaymentEvent)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "event", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "events", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(PaymentEvent, [{
    key: "render",
    value: function render() {
      var c = this.getContents();
      if (!c) return null;
      return _react.default.createElement("div", {
        className: "payment-event",
        "data-type": this.event.type,
        "data-event-id": this.event.id
      }, c);
    }
  }, {
    key: "getContents",
    value: function getContents() {
      switch (this.event.type) {
        case 'customer.subscription.created':
        case 'customer.subscription.updated':
          var ee = this.events.filter(function (ee) {
            return ee.type == 'customer.subscription.created' || ee.type == 'customer.subscription.updated';
          });

          if (ee[ee.length - 1] === this.event) {
            return _react.default.createElement("div", {
              className: _classList.default.join('subscription-create')
            }, _react.default.createElement("div", {
              className: "detail"
            }, _react.default.createElement("b", null, "Subscription Started"), " to ", _react.default.createElement("a", {
              href: this.event.data.object.plan.metadata.catalogItem.link
            }, this.event.data.object.plan.metadata.catalogItem.title), " for ", getSubscriptionPrice(this.event.data.object), " on ", new Date(this.event.data.object.current_period_start).format('F j, Y')), _react.default.createElement("div", {
              className: "amount"
            }));
          }

          return _react.default.createElement("div", {
            className: _classList.default.join('subscription-update', new Date(this.event.data.object.trial_end).getTime() > Date.now() ? 'pending' : '')
          }, _react.default.createElement("div", {
            className: "detail"
          }, _react.default.createElement("b", null, "Subscription", new Date(this.event.data.object.trial_end).getTime() > Date.now() ? ' Changing' : ' Changed'), " to ", _react.default.createElement("a", {
            href: this.event.data.object.plan.metadata.catalogItem.link
          }, this.event.data.object.plan.metadata.catalogItem.title), " for ", getSubscriptionPrice(this.event.data.object), " on ", (this.event.data.object.status == 'trialing' ? new Date(this.event.data.object.trial_end) : new Date(this.event.data.object.current_period_start)).format('F j, Y')), _react.default.createElement("div", {
            className: "amount"
          }));

        case 'charge.succeeded':
          return _react.default.createElement("div", {
            className: "charge-success"
          }, _react.default.createElement("div", {
            className: "detail"
          }, _react.default.createElement("b", null, "Payment Success"), " on ", new Date(this.event.created).format('F j, Y'), " at ", new Date(this.event.created).format('g:i A'), this.event.data.object.receipt_number ? _react.default.createElement("span", {
            className: "receipt"
          }, "Order #", this.event.data.object.receipt_number) : null), _react.default.createElement("div", {
            className: "amount"
          }, "$", (this.event.data.object.amount / 100).toFixed(2)));

        case 'charge.refunded':
          return _react.default.createElement("div", {
            className: "charge-refund"
          }, _react.default.createElement("div", {
            className: "detail"
          }, _react.default.createElement("b", null, "Refund Processed"), " on ", new Date(this.event.created).format('F j, Y'), " at ", new Date(this.event.created).format('g:i A')), _react.default.createElement("div", {
            className: "amount"
          }, "($", (this.event.data.object.amount_refunded / 100).toFixed(2), ")"));

        default:
          return _react.default.createElement("pre", {
            className: "unknown-object"
          }, JSON.stringify(this.event, null, 4));
      }
    }
  }]);
  return PaymentEvent;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "events", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
var PaymentEntry = (_class3 = (_temp2 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(PaymentEntry, _Component2);

  function PaymentEntry() {
    var _babelHelpers$getProt2;

    var _this2;

    babelHelpers.classCallCheck(this, PaymentEntry);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(PaymentEntry)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this2, "item", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    babelHelpers.initializerDefineProperty(_this2, "refresh", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this2)));
    _this2.state = {
      paymentsVisible: false
    };
    return _this2;
  }

  babelHelpers.createClass(PaymentEntry, [{
    key: "togglePayments",
    value: function togglePayments() {
      this.setState(function (st) {
        return {
          paymentsVisible: !st.paymentsVisible
        };
      });
    }
  }, {
    key: "listItems",
    value: function listItems() {
      var currentPlan = null;
      return this.item.stripeInfo.events.filter(function (item, index) {
        if (item.type == 'customer.subscription.created') {
          if (item.data.object.metadata.previousSubscription) {
            currentPlan = item.data.object.plan.id;
            return true;
          }

          return true;
        }

        if (item.type == 'customer.subscription.updated') {
          if (item.data.object.cancel_at_period_end) return false;
          if (item.data.object.plan.id != currentPlan) return true;
          return false;
        }

        if (item.type.indexOf('customer.') == 0) return false;
        if (item.type.indexOf('charge.') == 0 && (item.data.object.description || "").indexOf('Trial period for') == 0) return false;
        return true;
      });
    }
  }, {
    key: "cancelSubscription",
    value: function cancelSubscription() {
      // SiteLayout.current.navigate('upgrade');
      new CancelSubscriptionModal(this.item, this.refresh).show();
    }
  }, {
    key: "render",
    value: function render() {
      var CT = new Date(this.item.created);
      var items = this.listItems();
      var c = this.item.stripeInfo.events.filter(function (item) {
        return item.type.indexOf('customer.subscription') == 0;
      }),
          sub;

      if (c[0]) {
        sub = c[0];
      }

      return _react.default.createElement("div", {
        className: _classList.default.join('payment-item', this.state.paymentsVisible ? 'expanded' : null)
      }, _react.default.createElement("div", {
        className: "payment-line",
        "data-payment-id": this.item.id,
        "data-active": this.item.active
      }, _react.default.createElement("time", {
        className: "purchase-date",
        dateTime: this.item.created
      }, _react.default.createElement("div", {
        className: "month"
      }, CT.format('M')), _react.default.createElement("div", {
        className: "date"
      }, CT.format('j')), _react.default.createElement("div", {
        className: "year"
      }, CT.format('Y'))), _react.default.createElement("div", {
        className: "purchased-item",
        "data-item-id": this.item.catalogItem.id,
        "data-item-type": this.item.catalogItem.type
      }, _react.default.createElement("div", {
        className: "item-type"
      }, this.item.catalogItem.typeLabel), _react.default.createElement("a", {
        className: "item-title",
        href: this.item.catalogItem.link
      }, this.item.catalogItem.title), this.getItemPrice()), _react.default.createElement("div", {
        className: "controls"
      }, this.item.stripeInfo.type == 'subscription' && this.item.active && sub && sub.data.object.cancel_at_period_end == false && _react.default.createElement("button", {
        onClick: this.cancelSubscription,
        type: "button"
      }, "Cancel Subscription"), !!items.length && _react.default.createElement("button", {
        onClick: this.togglePayments,
        type: "button"
      }, this.state.paymentsVisible ? 'Close Payments' : 'View Payments'))), this.state.paymentsVisible && _react.default.createElement("div", {
        className: "payments-content"
      }, items.map(function (event) {
        return _react.default.createElement(PaymentEvent, {
          events: items,
          event: event,
          key: event.id
        });
      })));
    }
  }, {
    key: "getItemPrice",
    value: function getItemPrice() {
      if (this.item.stripeInfo.type == 'subscription') {
        var c = this.item.stripeInfo.events.filter(function (item) {
          return item.type.indexOf('customer.subscription') == 0;
        });
        var subsInEvents = {};
        c.forEach(function (item) {
          if (!subsInEvents[item.data.object.id]) subsInEvents[item.data.object.id] = item.data.object;
        });
        var sub = subsInEvents[this.item.id];
        var baseSub = sub;

        if (sub && sub.status == 'trialing') {
          if (sub.metadata.previousSubscription) sub = subsInEvents[sub.metadata.previousSubscription];
        }

        if (sub) {
          var plan = sub.plan;
          return _react.default.createElement("div", {
            className: "item-price"
          }, _react.default.createElement("span", {
            className: sub.cancel_at_period_end || sub.status == 'canceled' ? 'canceled' : null
          }, sub.status == 'trialing' ? "".concat((new Date(sub.trial_end).getTime() - new Date(sub.trial_start).getTime()) / 86400000, " day free trial - ") : '', getSubscriptionPrice(sub)), sub.status == 'canceled' ? _react.default.createElement("span", {
            className: "cancel-info"
          }, "Cancelled on ", new Date(sub.created).format('F j, Y')) : null, sub.status != 'canceled' && sub.cancel_at_period_end && sub.id == this.item.id ? _react.default.createElement("span", {
            className: "cancel-info"
          }, "Ending on ", new Date(sub.current_period_end).format('F j, Y')) : null, sub.status != 'canceled' && sub.cancel_at_period_end && sub.id != this.item.id ? _react.default.createElement("span", {
            className: "cancel-info"
          }, "Ending on ", new Date(sub.current_period_end).format('F j, Y'), "; will change to ", baseSub.plan.metadata.catalogItem.title, " at ", getSubscriptionPrice(baseSub)) : null);
        }

        return null;
      }

      if (this.item.stripeInfo.type == 'charge') {
        if (this.item.stripeInfo.events[0]) {
          return _react.default.createElement("div", {
            className: "item-price"
          }, _react.default.createElement("span", {
            className: this.item.active ? null : 'canceled'
          }, "$", (this.item.stripeInfo.events[0].data.object.amount / 100).toFixed(2), this.item.stripeInfo.events[0].data.object.receipt_number ? " | Order #".concat(this.item.stripeInfo.events[0].data.object.receipt_number) : ''), this.item.active ? null : _react.default.createElement("span", {
            className: "cancel-info"
          }, "Refunded on ", new Date(this.item.stripeInfo.events[0].created).format('F j, Y')));
        }

        return null;
      }
    }
  }]);
  return PaymentEntry;
}(_react.Component), _temp2), (_descriptor3 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "item", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class3.prototype, "refresh", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function () {};
  }
}), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "togglePayments", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "togglePayments"), _class3.prototype), babelHelpers.applyDecoratedDescriptor(_class3.prototype, "cancelSubscription", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "cancelSubscription"), _class3.prototype)), _class3);
var PaymentsBody = (_class5 = (_temp3 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(PaymentsBody, _Component3);

  function PaymentsBody() {
    var _babelHelpers$getProt3;

    var _this3;

    babelHelpers.classCallCheck(this, PaymentsBody);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this3 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt3 = babelHelpers.getPrototypeOf(PaymentsBody)).call.apply(_babelHelpers$getProt3, [this].concat(args)));
    _this3.state = {
      payments: null
    };
    return _this3;
  }

  babelHelpers.createClass(PaymentsBody, [{
    key: "refresh",
    value: function refresh() {
      var _this4 = this;

      (0, _fetch.default)('purchase/history').then(function (data) {
        return data.json();
      }).then(function (payments) {
        return _this4.setState({
          payments: payments
        });
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.refresh();
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      return _react.default.createElement("div", {
        className: "payments"
      }, this.state.payments ? this.state.payments.purchases.map(function (pmt) {
        return _react.default.createElement(PaymentEntry, {
          item: pmt,
          key: pmt.id,
          refresh: _this5.refresh
        });
      }) : null);
    }
  }]);
  return PaymentsBody;
}(_react.Component), _temp3), (babelHelpers.applyDecoratedDescriptor(_class5.prototype, "refresh", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class5.prototype, "refresh"), _class5.prototype)), _class5);
/* foo */

exports.PaymentsBody = PaymentsBody;
var CancelSubscriptionBody = (_class7 = (_temp4 =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(CancelSubscriptionBody, _Component4);

  function CancelSubscriptionBody() {
    var _babelHelpers$getProt4;

    var _this6;

    babelHelpers.classCallCheck(this, CancelSubscriptionBody);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this6 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt4 = babelHelpers.getPrototypeOf(CancelSubscriptionBody)).call.apply(_babelHelpers$getProt4, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this6, "subscription", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "refresh", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    babelHelpers.initializerDefineProperty(_this6, "modal", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this6)));
    _this6.state = {
      cancelled: false,
      loading: false,
      error: null
    };
    return _this6;
  }

  babelHelpers.createClass(CancelSubscriptionBody, [{
    key: "closeModal",
    value: function closeModal() {
      if (this.state.loading) return;
      this.modal.hide();
    }
  }, {
    key: "doCancel",
    value: function doCancel() {
      var _this7 = this;

      if (this.state.loading) return;
      this.setState({
        loading: true
      }, function () {
        (0, _fetch.default)('purchase/cancel', {
          method: 'POST',
          headers: {
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            subscriptionId: _this7.subscription.id
          })
        }).then(function (data) {
          return data.json();
        }).then(function (data) {
          // FIXME: We should pay attention to 'data' here.
          if (data.success) {
            _this7.setState({
              loading: false,
              cancelled: true,
              error: null
            });

            _this7.refresh();
          } else {
            _this7.setState({
              loading: false,
              error: data.error
            });
          }
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var c = this.subscription.stripeInfo.events.filter(function (item) {
        return item.type.indexOf('customer.subscription') == 0;
      });
      var subscriptionObject = c[0].data.object;

      if (this.state.cancelled) {
        return _react.default.createElement("div", {
          className: "cancel"
        }, _react.default.createElement("h2", null, "Your subscription has been canceled."), subscriptionObject.status == 'trialing' ? null : _react.default.createElement("p", null, "You will continue to have access to the materials until your paid period ends on ", new Date(subscriptionObject.current_period_end).format('F j, Y'), "."), _react.default.createElement("button", {
          type: "button",
          className: "btn btn-primary",
          onClick: this.closeModal
        }, "OK"));
      }

      return _react.default.createElement("div", {
        className: "cancel"
      }, this.state.error ? _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error) : null, _react.default.createElement("h2", null, "Are you sure you want to cancel your subscription to ", this.subscription.catalogItem.title, "?"), _react.default.createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.doCancel,
        disabled: this.state.loading
      }, "Yes, cancel this subscription now."), _react.default.createElement("div", null, _react.default.createElement("a", {
        href: "javascript:void(0)",
        onClick: this.closeModal
      }, "No, I do not want to cancel this subscription")));
    }
  }]);
  return CancelSubscriptionBody;
}(_react.Component), _temp4), (_descriptor5 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "subscription", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "refresh", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class7.prototype, "modal", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "closeModal", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "closeModal"), _class7.prototype), babelHelpers.applyDecoratedDescriptor(_class7.prototype, "doCancel", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class7.prototype, "doCancel"), _class7.prototype)), _class7);

var CancelSubscriptionModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(CancelSubscriptionModal, _Modal);

  function CancelSubscriptionModal(sub, refresh) {
    var _this8;

    babelHelpers.classCallCheck(this, CancelSubscriptionModal);
    _this8 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(CancelSubscriptionModal).call(this, 'cancel-subscription-modal'));
    _this8.innerWrapper = false;
    _this8.hasModalTitleElement = false;
    _this8.subscription = sub;

    _this8.refresh = refresh || function () {};

    return _this8;
  }

  babelHelpers.createClass(CancelSubscriptionModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get,
          _this9 = this;

      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return (_babelHelpers$get = babelHelpers.get(babelHelpers.getPrototypeOf(CancelSubscriptionModal.prototype), "show", this)).call.apply(_babelHelpers$get, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(CancelSubscriptionBody, {
          subscription: _this9.subscription,
          refresh: _this9.refresh,
          modal: _this9
        }), element.querySelector('.form-body'));

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body'></div>\n\t\t";
    }
  }]);
  return CancelSubscriptionModal;
}(_base.default);

var PaymentsModal =
/*#__PURE__*/
function (_Modal2) {
  babelHelpers.inherits(PaymentsModal, _Modal2);

  function PaymentsModal() {
    var _this10;

    babelHelpers.classCallCheck(this, PaymentsModal);
    _this10 = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(PaymentsModal).call(this, 'payments-modal'));
    _this10.innerWrapper = false;
    return _this10;
  }

  babelHelpers.createClass(PaymentsModal, [{
    key: "show",
    value: function show() {
      var _babelHelpers$get2;

      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return (_babelHelpers$get2 = babelHelpers.get(babelHelpers.getPrototypeOf(PaymentsModal.prototype), "show", this)).call.apply(_babelHelpers$get2, [this].concat(args)).then(function (element) {
        _reactDom.default.render(_react.default.createElement(PaymentsBody, null), element.querySelector('.form-body'));

        $(element).find('.modal').on('hidden.bs.modal', function (event) {
          _reactDom.default.unmountComponentAtNode(element.querySelector('.form-body'));

          $(element).remove();
        });
        return element;
      });
    }
  }, {
    key: "title",
    get: function get() {
      return 'My Purchases';
    }
  }, {
    key: "modalContent",
    get: function get() {
      return "\n\t\t\t<div class='form-body'></div>\n\t\t";
    }
  }]);
  return PaymentsModal;
}(_base.default);

exports.PaymentsModal = PaymentsModal;

function show() {
  new PaymentsModal().show();
}